import {Component, EventEmitter, Input, OnChanges, Output} from '@angular/core';

@Component({
  selector: 'app-password-validation',
  templateUrl: './password-validation.component.html',
  styleUrls: ['./password-validation.component.css']
})
export class PasswordValidationComponent implements OnChanges {

  @Input() password: string = '';
  progress = 0;
  @Output()
  onStrengthChanged: EventEmitter<number> = new EventEmitter();

  requirements = [
    { key: 'lowercase', message: 'contains at least one lower character', isValid: false },
    { key: 'uppercase', message: 'contains at least one upper character', isValid: false },
    { key: 'digit', message: 'contains at least one digit character', isValid: false },
    { key: 'special', message: 'contains at least one special character', isValid: false },
    { key: 'length', message: 'contains at least 8 characters', isValid: false }
  ];

  ngOnChanges() {
    this.validatePassword();
    this.updateProgress();
  }

  validatePassword(): void {
    this.requirements.forEach((requirement) => {
      switch (requirement.key) {
        case 'lowercase':
          requirement.isValid = /[a-z]/.test(this.password);
          break;
        case 'uppercase':
          requirement.isValid = /[A-Z]/.test(this.password);
          break;
        case 'digit':
          requirement.isValid = /[0-9]/.test(this.password);
          break;
        case 'special':
          requirement.isValid = /[!@#$%^&*(),.?":{}|<>]/.test(this.password);
          break;
        case 'length':
          requirement.isValid = this.password.length >= 8;
          break;
      }
    });
  }

  updateProgress(): void {
    const fulfilledRequirements = this.requirements.filter((req) => req.isValid).length;
    this.progress = Math.round((fulfilledRequirements / this.requirements.length) * 100);
    this.onStrengthChanged.emit(this.progress);
  }
}
